import { motion } from "framer-motion";
import { Reveal } from "./anim";
import { MANIFESTO } from "./data";

export const Manifesto = () => (
  <section
    id="process"
    data-testid="process-section"
    className="relative border-y border-[hsl(var(--border))] bg-[hsl(var(--bg-soft))] px-6 py-28 md:px-10 md:py-36"
  >
    <div className="mx-auto max-w-[1400px]">
      <Reveal>
        <p className="mb-4 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
          <span className="h-px w-8 bg-[hsl(var(--primary))]" /> The process
        </p>
        <h2 className="max-w-3xl font-head text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">
          How it works — and why your first call is free.
        </h2>
      </Reveal>

      <div className="mt-16 divide-y divide-[hsl(var(--border))]">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.no} delay={i * 0.06}>
            <motion.div
              whileHover={{ x: 12 }}
              transition={{ type: "spring", stiffness: 250, damping: 22 }}
              data-testid={`process-step-${i}`}
              className="group grid gap-4 py-10 md:grid-cols-[auto_1fr_2fr] md:items-center md:gap-12"
            >
              <span className="font-head text-5xl font-bold text-[hsl(var(--primary))] md:text-7xl">
                {m.no}
              </span>
              <h3 className="font-head text-2xl font-semibold md:text-3xl">{m.title}</h3>
              <p className="max-w-xl text-base leading-relaxed text-[hsl(var(--muted))]">
                {m.body}
              </p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
